export default __webpack_public_path__ + "assets/home-one-four.4bddc9c5afdc9156930e84ed6d75b6d3.png";